package com.anjuros.website.templates.template1.modules

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalUiMode
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.templates.selection.util.Constants.placeholderPrimaryColor
import com.anjuros.website.templates.selection.util.Constants.placeholderPrimaryColorOpacity
import com.anjuros.website.templates.template4.modules.Template4Theme
import com.anjuros.website.templates.template5.modules.Template5Theme
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.argb
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.rgb

enum class Template1Theme(
    val hex: String,
    val rgb: CSSColorValue
) {

    Primary(hex = "#D7A287", rgb = rgb(r = 215, g = 162, b = 135)),
    OpacityPrimary(hex = "#00A78E", rgb = argb(a=0.8f,r = 215, g = 162, b = 135)),
    Secondary(hex = "#121D34", rgb =  rgb(105, 100, 96)),
    LightGray(hex = "#EDEDED", rgb = rgb(r = 237, g = 237, b = 237)),
    LighterGray(hex = "#F9F9F9", rgb = rgb(r = 249, g = 249, b = 249)),
    DarkGrey(hex = "#F9F9F9", rgb = rgb(r = 36, g = 37, b = 43)),
    DarkGreyOpacity(hex = "#F9F9F9", rgb = argb(a=0.8f,r = 36, g = 37, b = 43)),
    FacebookColor(hex = "#1877F2", rgb = rgb(r = 24, g = 119, b = 242)),
    InstagramColor(hex = "#ee2a7b", rgb = rgb(r = 238, g = 42, b = 123)),
    SectionSubtitle(hex = "#ee2a7b", rgb =  rgb(110, 105, 100))
}

@Composable
fun Template1Theme.getColor():CSSColorValue{
    return  if(LocalUiMode.current== UiMode.NORMAL)
        this.rgb
    else
        placeholderPrimaryColor.rgb
}

@Composable
fun Template1Theme.getColorOpacity():CSSColorValue{
    return  if(LocalUiMode.current== UiMode.NORMAL)
        this.rgb
    else
        placeholderPrimaryColorOpacity.rgb
}